import { arrayOf, bool, func, number, oneOf, oneOfType, shape, string } from "prop-types";
import { customTextPropType, defaultCustomTextPropType } from "../CustomText/customTextPropType";

/*
    If you change the structure in this file, you must check:
        CustomButton.js and ExampleButton.js

    (This will not break any component that is using
        CustomButton if you just add keys)
*/

/* CustomButton Data Structure Guide */
export const customButtonDataStructureGuide = {
    icon: string,
    func,
    type: oneOf(["button", "submit", "reset"]),
    linkTo: string,
    loading: bool,
    pullRight: bool,
    options: arrayOf(
        shape({
            string,
            func,
            text: oneOfType([string, number]),
            textType: oneOf(["STRING", "MONEY", "NUMBER", "PERCENTAGE", "DATE", "I18N", "ARS", "USD"]),
            className: string,
            keepSpaceIfNoText: bool,
        }),
    ),
    text: oneOfType([string, number]),
    textType: oneOf(["STRING", "MONEY", "NUMBER", "PERCENTAGE", "DATE", "I18N", "ARS", "USD"]),
    className: string,
    keepSpaceIfNoText: bool,
};

export const availableBtnClasses = [
    "btn",
    "btn-small",
    "btn-outline",
    "btn-primary",
    "flex",
    "btn-block",
    "btn-only-icon",
    "btn-circle",
    "btn-link",
    "btn-quiet",
    "btn-tab",
    "btn-asLink",
    "btn-login",
    "btn-image",
    "btn-mb",
];

/* ButtonOption PropType */

export const buttonOptionPropType = {
    icon: string,
    func,
    disabled: bool,
    ...customTextPropType,
};

export const defaultButtonOptionPropType = {
    icon: "",
    func: () => {},
    disabled: false,
    ...defaultCustomTextPropType,
};

/* CustomButton PropType */

export const customButtonPropType = {
    icon: string,
    func,
    type: oneOf(["button", "submit", "reset"]),
    linkTo: string,
    pullRight: bool,
    options: arrayOf(shape(buttonOptionPropType)),
    loading: bool,
    isMobile: bool.isRequired,
    ...customTextPropType,
};

export const defaultCustomButtonPropType = {
    icon: "",
    func: () => {},
    type: "button",
    linkTo: "",
    pullRight: false,
    loading: false,
    options: [],
    ...defaultCustomTextPropType,
};
